import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-20 overflow-hidden bg-soft-cream" data-id="element-95" data-mp="ek6a8z55amd0">
      {/* Background Image with Soft Overlay */}
      <div className="absolute inset-0 z-0 opacity-25" data-id="element-96" data-mp="9l37jlcn0s87">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/ntvlqtkffhdbb8r9fejcsv/998f55ba-f676-4af8-a27d-47f6f60444b4/DSC_8291.jpg" alt="Enchanted fairy party setup in a woodland with a soft pink tent" className="w-full h-full object-cover object-center" data-id="element-97" data-mp="4mi4le603ug2" />
        
        <div className="absolute inset-0 bg-warm-ivory/80 backdrop-blur-[2px]" data-id="element-98" data-mp="sai3j1dgur5q"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-soft-cream/50 to-soft-cream" data-id="element-99" data-mp="ncq0bb7dfim8"></div>
      </div>

      <div className="relative z-20 max-w-4xl mx-auto px-6 text-center" data-id="element-100" data-mp="3d1scj2wkntvr">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: [0, -8, 0]
      }} transition={{
        opacity: {
          duration: 0.8,
          ease: 'easeOut'
        },
        scale: {
          duration: 0.8,
          ease: 'easeOut'
        },
        y: {
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }
      }} className="w-36 md:w-44 h-auto mx-auto mb-6" data-id="element-101" data-mp="382fhvvzgliim">
          
          <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/ntvlqtkffhdbb8r9fejcsv/998f55ba-f676-4af8-a27d-47f6f60444b4/Asset_54x.png" alt="Wishing Tree brand mark" className="w-full h-auto [filter:drop-shadow(0_2px_6px_rgba(107,94,87,0.35))]" data-id="element-102" data-mp="30hhohjpct6xy" />
          
        </motion.div>
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl text-soft-terracotta leading-tight mb-6 font-normal font-[Merriweather,_serif]" data-id="element-103" data-mp="2vi55xb5imm16">
          
          Dream. Wish. <br className="hidden md:block" data-id="element-104" data-mp="s3uqhvk0f6a3" />
          <span className="italic font-light relative inline-block" data-id="element-105" data-mp="nb1j0zx5pjub">
            Celebrate.
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="md:text-xl text-soft-dark mb-10 max-w-2xl mx-auto font-light font-[Avenir,_sans-serif] text-[18px]" data-id="element-106" data-mp="icrn2n3lyf7n">
          
          Let us handle the planning, styling, and setup while you focus on
          celebrating with your child and making memories together.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6" data-id="element-107" data-mp="x0l8iofdkby5">
          
          <motion.a whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} href="#contact" className="w-full sm:w-auto bg-soft-terracotta text-white px-8 py-3.5 text-sm uppercase tracking-widest font-medium rounded-full shadow-sm hover-bg-soft-terracotta transition-all" data-id="element-108" data-mp="1x783xkq1jlsj">
            
            Plan My Party
          </motion.a>
          <motion.a whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} href="#themes" className="w-full sm:w-auto bg-soft-rose text-white px-8 py-3.5 text-sm uppercase tracking-widest font-medium rounded-full shadow-sm hover-bg-soft-rose transition-all" data-id="element-109" data-mp="2fz0wje1774zq">
            
            View Themes
          </motion.a>
        </motion.div>
      </div>

      {/* Delicate hairline bottom divider */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-soft-terracotta/20 to-transparent z-10" data-id="element-110" data-mp="uokebphu3v7b"></div>
    </section>;
}